import styled from "styled-components";

const Span = styled.span`
  background: #f2f2f2;
  padding: 2px 5px;
  border-radius: 5px;
  margin-right: 15px;
  font-size: 13px;
`;
export default Span;
